export default __webpack_public_path__ + "static/media/download-icon.cc1f941e.svg";